export default "__VITE_ASSET__Tpbv03sv__"